import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { pb } from "@/lib/pocketbase";
import { Collections, type DoctorsResponse } from "@/types/pocketbase.ts";
import type { FullListOptions, ListOptions, OneOptions } from "@/types/query-options";

const COLLECTION = Collections.Doctors;

export const doctorsQueries = {
	all: () => [COLLECTION],
	lists: () => [...doctorsQueries.all(), "list"],
	list: <Texpand = unknown>(params: ListOptions = { page: 1, perPage: 10, options: {} }) =>
		queryOptions({
			queryKey: [...doctorsQueries.lists(), { page: params.page, perPage: params.perPage, options: params.options }],
			queryFn: () =>
				pb.collection(COLLECTION).getList<DoctorsResponse<Texpand>>(params.page, params.perPage, params.options),
			placeholderData: keepPreviousData,
		}),
	fullLists: () => [...doctorsQueries.lists(), "fullList"],
	fullList: <Texpand = unknown>(options?: FullListOptions) =>
		queryOptions({
			queryKey: [...doctorsQueries.fullLists(), options ?? {}],
			queryFn: () =>
				pb.collection(COLLECTION).getFullList<DoctorsResponse<Texpand>>({
					...options?.options,
					sort: options?.options?.sort ?? "-created",
				}),
			placeholderData: keepPreviousData,
		}),
	ones: () => [...doctorsQueries.all(), "one"],
	one: <Texpand = unknown>(params?: OneOptions) =>
		queryOptions({
			queryKey: [...doctorsQueries.ones(), params?.id, params?.options ?? {}],
			queryFn: () => pb.collection(COLLECTION).getOne<DoctorsResponse<Texpand>>(params?.id ?? "", params?.options),
			enabled: Boolean(params?.id),
		}),
};
